import React from "react";
import PropTypes from "prop-types";
import { Button, CircularProgress } from "@mui/material";
import styles from "./WheelzButton.module.scss";

const WHEELZ_BUTTON_TYPES = {
  SECONDARY: "secondary",
  PRIMARY: "primary",
};

const WheelzButton = ({
  buttonText,
  width,
  height,
  buttonType,
  onClick,
  disabled,
  deCapitalizeText,
  loading = false,
  buttonFontSize,
  ...muiButtonProps
}) => {
  // Define a default onClick function that logs to the console
  const defaultOnClick = () => {
    // console.log("Button Clicked:", buttonText);
  };

  const renderButtonContent = () => (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
      }}
    >
      {/* Invisible placeholder to balance the layout */}
      {loading && <div style={{ width: 20, height: 20 }}></div>}
      <span style={{ flex: 1, textAlign: "center", fontSize: buttonFontSize }}>
        {buttonText || "Click Me"}
      </span>
      {loading && <CircularProgress size={20} style={{ color: "white" }} />}
    </div>
  );

  const commonStyle = {
    width: width || "wrap-content",
    height: height || "wrap-content",
    fontFamily: "Outfit, sans-serif",
    textTransform: deCapitalizeText ? "none" : "uppercase", // Control text capitalization
  };

  const secBtnStyle = {
    ...commonStyle,
    fontWeight: 600,
  };

  const primaryBtnStyle = {
    ...commonStyle,
    fontWeight: 700,
  };

  const secBtn = (
    <Button
      className={styles["secondary-btn"]}
      style={secBtnStyle}
      onClick={onClick || defaultOnClick}
      disabled={disabled}
      {...muiButtonProps} // Spread additional MUI Button props here
    >
      {renderButtonContent()}
    </Button>
  );

  const primaryBtn = (
    <Button
      className={styles["primary-btn"]}
      style={primaryBtnStyle}
      onClick={onClick || defaultOnClick}
      disabled={disabled}
      {...muiButtonProps} // Spread additional MUI Button props here
    >
      {renderButtonContent()}
    </Button>
  );

  // Return secBtn if buttonType is 'secondary', else return primaryBtn
  return buttonType === "secondary" ? secBtn : primaryBtn;
};

WheelzButton.propTypes = {
  buttonText: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  buttonType: PropTypes.oneOf(["secondary", "primary"]),
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  deCapitalizeText: PropTypes.bool,
  loading: PropTypes.bool,
  buttonFontSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export { WHEELZ_BUTTON_TYPES };
export default WheelzButton;
